import Link from 'next/link'
import { ComponentProps } from 'react'
import { cn } from '@/utils/cn'

export default function Option(props: ComponentProps<typeof Link>) {
  return (
    <Link
      {...props}
      // fix iOS not making things focusable by default,
      // breaking focused state styles
      tabIndex={0}
      className={cn(
        'input-border flex gap-4 px-6 py-3 bg-static-white text-primary text-l font-semibold rounded-xl',
        props.className,
      )}
    />
  )
}
